import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Table, Modal, Tabs, Tab, Badge} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import { FaCheck, FaFile, FaRegClock, FaExclamationCircle, FaFileInvoice, FaEdit, FaTrash } from "react-icons/fa";
import AsyncSelect from 'react-select/async';
import { formataDataHoraExibicao, getCurrentUser, formataCNPJ, formataCPF, formatarValor, aprovacaoNota, hasPerm, formatarValorAPI, formatarValorLocal, formatarValorAPISemDecimais } from '../../common/utils';
import PropTypes from 'prop-types';
import { Trans, withTranslation } from 'react-i18next';
import { idiomaAtual } from '../../i18n';

class FaturamentosEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.onChangeArquivo = this.onChangeArquivo.bind(this);
        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.state = {
            id: "",
            nota: "",
            nota_upload: "",
            laboratorio_id: "",
            data_envio: "",
            data_inicio: "",
            data_fim: "",
            valor_total: "",
            faturamento_credito_antecipacao: false,
            pago: false,
            pago_banco: false,
            data_pagamento: "",
            pagamento_comprovante: "",
            pagamento_comprovante_url: "",
            pagamento_forma_id: "",
            pagamento_url_cartao_credito: "",
            pagamento_chave_pix: "",
            pagamento_motivo_alteracao: "",
            nota_comissao_numero: "",
            nota_fiscal_status: "",
            nota_fiscal_motivo_recusa: "",
            nota_fiscal_motivo_recusa_banco: "",
            nota_fiscal_numero: "",
            data_vencimento: "",
            data_emissao: "",
            taxa_administrativa: "",
            taxa_administrativa_valor: "",
            tipo_pagamento: "",
            boleto_pagamento: "",
            boleto_pagamento_url: "",
            pagamento_banco: "",
            pagamento_agencia: "",
            pagamento_conta: "",
            pagamento_tipo_conta: "",
            pagamento_titular: "",
            programa_id: "",
            dados_laboratorio: {},
            dados_programa: {},
            lista_atendimentos: [],
            //item cujo valor esta sendo detalhado (servico x despesas)
            detalheDespesasItem: null,
            dados_vouchers: [],
            lista_historico_atendimentos: [],
            lista_historico_atendimentos_servicos: [],
            showModalAlteracaoAtendimento: false,
            showModalAlteracaoServico: false,
            showModalAlteracaoData: false,
            id_servico_data: '',
            data_servico_edicao: '',
            servicosPorAtendimento: {},
            formasPagamento: [ { pagamento_forma: null, forma_nome: '', slug: '' }],
            tipo_usuario: "",
            erroLoadRegistro: "",            
            titulo_pagina: "",
            loading: false,
            laboratorio_pagamento_forma_id: "",
            forma_atendimento_lab_selecionada: {},
            dados_credito_antecipacao: {},
            id_servico_atendimento: "",
            valor_servico_atendimento: 0,
            alteracao_servico_atendimento_titulo: "",
            tipo_faturamento: "",
            atendimentos_servicos: [],
            carregamentoAbas: [],
            logs_faturamento: [],
            dados_prestador: {},
            is_superuser: false,
            data_criacao: '',
            ordem_pagamento: '',
            observacoes: ''
        };

        // `text` é a chave de tradução do rótulo
        this.statusConfig = {
            aguardando: { background: '#f2f2f2', color: '#252f4a', text: 'faturamentos:nfStatus.aguardando', icon: <FaRegClock /> },
            analise: { background: '#f2f2f2', color: '#252f4a', text: 'faturamentos:nfStatus.analise', icon: <FaRegClock /> },
            recusado: { background: '#eb4961', color: '#fff', text: 'faturamentos:nfStatus.recusado', icon: <FaExclamationCircle /> },
            aprovado: { background: '#3cc172', color: '#fff', text: 'faturamentos:nfStatus.aprovado', icon: <FaCheck /> }
        };
    }

    componentDidMount(){
        const id = this.props.router.params.id;
        let dados_usuario = getCurrentUser();

        this.setState({
            tipo_usuario: dados_usuario.tipo_usuario,
            is_superuser: dados_usuario.is_superuser,
        })        

        if(id){
            this.setState({
                id: id,
                // título e erros de carga guardam a chave; são traduzidos no render
                titulo_pagina: 'faturamentos:edit.pageTitle',
                loading: true,
                erroLoadRegistro: ''
            })

            //consulta os dados do faturamento na api
            api.get(`/faturamento/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',                    
                    loading: false,
                    nota: dados.nota,
                    laboratorio_id: dados.laboratorio_id,
                    data_envio: dados.data_envio,
                    data_inicio: dados.data_inicio,
                    data_fim: dados.data_fim,
                    valor_total: dados.valor_total,
                    pago: dados.pago,
                    pago_banco: dados.pago,
                    data_pagamento: dados.data_pagamento,
                    pagamento_comprovante_url: dados.pagamento_comprovante,
                    pagamento_forma_id: dados.pagamento_forma_id,
                    pagamento_url_cartao_credito: dados.pagamento_url_cartao_credito,
                    pagamento_chave_pix: dados.pagamento_chave_pix,
                    pagamento_motivo_alteracao: dados.pagamento_motivo_alteracao,
                    laboratorio_pagamento_forma_id: dados.laboratorio_pagamento_forma_id,
                    forma_atendimento_lab_selecionada: dados.dados_laboratorio_pagamento_forma,
                    nota_fiscal_status: dados.nota_fiscal_status,
                    nota_fiscal_motivo_recusa: dados.nota_fiscal_motivo_recusa,
                    nota_fiscal_motivo_recusa_banco: dados.nota_fiscal_motivo_recusa,
                    nota_fiscal_numero: dados.nota_fiscal_numero,
                    data_vencimento: dados.data_vencimento,
                    data_emissao: dados.data_emissao,
                    nota_comissao_numero: dados.nota_comissao_numero,
                    taxa_administrativa: dados.taxa_administrativa,
                    taxa_administrativa_valor: dados.taxa_administrativa_valor,
                    boleto_pagamento_url: dados.boleto_pagamento,
                    pagamento_banco: dados.pagamento_banco,
                    pagamento_agencia: dados.pagamento_agencia,
                    pagamento_conta: dados.pagamento_conta,
                    pagamento_tipo_conta: dados.pagamento_tipo_conta,
                    pagamento_titular: dados.pagamento_titular,
                    programa_id: dados.programa_id,
                    dados_laboratorio: dados.dados_laboratorio,
                    //dados_programa: dados.dados_programa,
                    lista_atendimentos: dados.lista_atendimentos,
                    dados_vouchers: dados.dados_vouchers || [],
                    faturamento_credito_antecipacao: (dados.dados_credito_antecipacao && dados.dados_credito_antecipacao.length > 0) ? true : false,
                    dados_credito_antecipacao: dados.dados_credito_antecipacao,
                    lista_historico_atendimentos: dados.dados_historico_atendimentos,
                    lista_historico_atendimentos_servicos: dados.dados_historico_atendimentos_servicos,
                    cancelado: dados.cancelado,
                    data_criacao: dados.data_criacao,
                    ordem_pagamento: dados.ordem_pagamento,
                    observacoes: dados.observacoes,
                }, () => {
                    if(this.state.lista_atendimentos.length > 0){
                        this.setState({
                            valor_total: 0
                        }, () => {
                            this.setState({
                                valor_total: this.state.lista_atendimentos.reduce((total, servico) => total + parseFloat(servico.valor_atendimento || servico.valor || 0), parseFloat(this.state.valor_total || 0))
                            })
                        })
                    }
                    
                    this.carregaDadosPrestador();
                    this.carregaDadosPrograma(this.state.programa_id);
                })
                this.carregarFormasPagamento()
                //this.carregarServicos()
            })
            .catch(error => {
                let erro_msg = 'faturamentos:edit.errors.load';

                if(error.response && error.response.status === 500){
                    erro_msg = 'faturamentos:errors.serverRetry';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        
    }

    // helper para calcular e persistir os totais no faturamento
    atualizaTotaisFaturamento = async () => {
        const faturamentoId = this.state.id || this.props.match?.params?.id;

        // 1) GET faturamento para obter a lista atualizada de atendimentos
        const resp = await api.get(`/faturamento/${faturamentoId}`);
        const dados = resp.data;

        // 2) Soma dos atendimentos (valor_atendimento || valor)
        const total = (dados.lista_atendimentos || []).reduce((acc, item) => {
            const v = parseFloat(item.valor_atendimento ?? item.valor ?? 0) || 0;
            return acc + v;
        }, 0);

        // 3) PUT no faturamento salvando "valor_total" e "nota_fiscal_valor"
        const fd = new FormData();
        fd.append('valor_total', total);
        fd.append('nota_fiscal_valor', total);

        await api({
            method: 'put',
            url: `/faturamento/${faturamentoId}/`,
            data: fd,
        });
    };

    handleChangeAtendimento = (e, index, fieldName) => {   

        let { name, value } = e.target;
        const { atendimentos_servicos } = this.state;

        if(fieldName == 'valor'){
            value = formatarValor(value);
        }

        const updatedAtendimentosServicos = [...atendimentos_servicos];
        updatedAtendimentosServicos[index][name] = value;

        this.setState({
            atendimentos_servicos: updatedAtendimentosServicos
        });

    }   

    quebraLinhaHistorico = (descricao) => {
        return descricao
    }

    alterarValorServicoAtendimento = (id, tipo_faturamento, valor) => {
        if(tipo_faturamento == 'atendimento'){ 
            //busca os atendimentos
            api.get(`/atendimentos/servicos/?atendimento_id=${id}`)
            .then(response => {
                const dados = response.data;

                this.setState({
                    atendimentos_servicos: dados.results.map(servico => ({
                        ...servico,
                        valor: servico.valor ? formatarValor(servico.valor) : ''
                    }))
                });

                this.setState({
                    showModalAlteracaoAtendimento: true,
                    id_servico_atendimento: id,
                    valor_anterior: valor,
                    valor_servico_atendimento: formatarValor(valor),
                    alteracao_servico_atendimento_titulo: 'faturamentos:edit.changeEncounterValue',
                    tipo_faturamento: tipo_faturamento
                })
            })
            .catch(error => {
                console.error('Erro ao carregar atendimento:', error);
                Swal.fire(this.props.t('faturamentos:edit.errorTitle'), this.props.t('faturamentos:edit.errors.loadEncounter'), 'error');
            });
        } else {
            this.setState({
                showModalAlteracaoServico: true,
                id_servico_atendimento: id,
                valor_servico_atendimento: valor,
                alteracao_servico_atendimento_titulo: 'faturamentos:edit.changeServiceValue',
                tipo_faturamento: tipo_faturamento
            })
        }
    }

    enviaRegistroAlteracaoAtendimento = (e) => {
        e.preventDefault();
        const { t } = this.props;
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: <p>{t('faturamentos:edit.confirm.saveChanges')}</p>,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('common:label.yes'),
            cancelButtonText: t('common:label.no'),
            showCloseButton: true,
        }).then(async (result) => {
            if (!result.isConfirmed) return;

            this.setState({ loading: true });

            try {
                // Cria um array de Promises para aguardar tudo
                const requests = this.state.atendimentos_servicos.map((servico) => {
                    // 1) PUT do serviço
                    const fdServico = new FormData();
                    fdServico.append('valor', formatarValorAPI(servico.valor));
                    fdServico.append('valor_anterior', formatarValorAPI(this.state.valor_anterior));
                    fdServico.append('valor_total_anterior', this.state.valor_total);

                    const putServico = api({
                        method: 'put',
                        url: `/atendimentos/servicos/${servico.id}/`,
                        data: fdServico,
                    });

                    // 2) Se faturamento for por atendimento, PUT no atendimento com valor_atendimento
                    if (this.state.tipo_faturamento === 'atendimento') {
                        const fdAtendimento = new FormData();
                        fdAtendimento.append('valor_atendimento', formatarValorAPI(servico.valor));

                        const putAtendimento = api({
                            method: 'put',
                            url: `/atendimentos/${this.state.id_servico_atendimento}/`,
                            data: fdAtendimento,
                        });

                        // Retorna uma Promise que aguarda os dois PUTs
                        return Promise.all([putServico, putAtendimento]);
                    }

                    // Caso contrário, só o PUT do serviço
                    return putServico;
                });

                // Aguarda todas as requisições
                await Promise.all(requests);

                if (this.state.tipo_faturamento === 'atendimento') {
                    await this.atualizaTotaisFaturamento();
                }

                await MySwal.fire({
                    title: <p>{t('faturamentos:edit.success.valueChanged')}</p>,
                    icon: 'success',
                    showCloseButton: true,
                });

                window.location.reload();
            } catch (error) {
                console.error('Erro ao salvar alterações:', error);
                this.setState({ loading: false });
                MySwal.fire({
                    title: <p>{t('faturamentos:edit.errors.saveGeneric')}</p>,
                    text: t('faturamentos:edit.errors.saveGenericText'),
                    icon: 'error',
                    showCloseButton: true,
                });
            }
        });
    };

    enviaRegistroAlteracaoServicoAtendimento = (e) => {
        e.preventDefault();
        const { t } = this.props;

        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: <p>{t('faturamentos:edit.confirm.changeValue')}</p>,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('common:label.yes'),
            cancelButtonText: t('common:label.no'),
            showCloseButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({
                    loading: true,
                });

                const formData = new FormData();
                formData.append('valor', formatarValorAPI(this.state.valor_servico_atendimento));
                formData.append('tipo_faturamento', this.state.tipo_faturamento);
                formData.append('valor_total_anterior', this.state.valor_total);
                let url = `/atendimentos/servicos/${this.state.id_servico_atendimento}/`;

                api({
                    method: 'put',
                    url: url,
                    data: formData,
                })
                .then(response => {
                    this.setState({
                        loading: false,
                        showModalAlteracaoServicoAtendimento: false
                    });

                    MySwal.fire({
                        title: <p>{t('faturamentos:edit.success.valueChanged')}</p>,
                        icon: 'success',
                        showCloseButton: true,
                    }).then((result) => {
                        window.location.reload();
                    });             
                })
                .catch(error => {
                    let erro_msg = t('faturamentos:edit.errors.changeValue');            

                    if (error.response && error.response.status === 500) {
                        erro_msg = t('faturamentos:errors.server');
                    }

                    MySwal.fire({
                        icon: 'error',
                        showCloseButton: true,
                        title: <p>{erro_msg}</p>,
                    });

                    this.setState({
                        loading: false,
                    });
                });
            }
        });
    }

    carregaDadosPrograma = (programa_id) => {
        if (programa_id) {
            api.get(`/programas/${programa_id}/`)
                .then(response => {
                    let dadosResponse = response.data;

                    // Verifica condição especial para o programa IDHentifique (se for faturamento mais antigo que a data de 2025-10-11 então deve tratar o tipo_faturamento como atendimento)
                    if (dadosResponse?.nome === 'Servier - IDHentifique') {
                        const dataCriacao = new Date(this.state.data_criacao);
                        const dataLimite = new Date("2025-10-11");

                        if (dataCriacao < dataLimite) {
                            // Mantém o tipo antigo
                            dadosResponse.tipo_faturamento = "atendimento";
                        } 
                    }

                    this.setState({ dados_programa: dadosResponse });
                })
                .catch(error => {
                    console.error('Erro ao carregar dados do programa atual:', error);
                });
        }
    };

    carregaDadosPrestador = () => {
        if (hasPerm('view_prestadores') && this.state.laboratorio_id) {
            api.get(`/pessoas/prestadores/${this.state.laboratorio_id}/`)
                .then(response => {
                    const dadosResponse = response.data;
                    this.setState({ dados_prestador: dadosResponse });
                })
                .catch(error => {
                    console.error('Erro ao carregar dados do prestador', error);
                    //Sentry.captureException('Erro ao carregar dados do programa atual:', error);
                    
                    let erro_msg = 'faturamentos:edit.errors.loadProvider';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'faturamentos:errors.serverRetry';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();
        const { t } = this.props;

        const MySwal = withReactContent(Swal);

        if( this.state.tipo_usuario === "prestador" ) {
            if(!this.state.nota_upload && (!this.state.nota_fiscal_status || this.state.nota_fiscal_status === 'recusado')) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>{t('common:alert.attention')}</p>,
                    text: t('faturamentos:edit.validation.invoiceRequired'),
                    showCloseButton: true,
                });
                return;
            }

            if(!this.state.nota_fiscal_numero) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>{t('common:alert.attention')}</p>,
                    text: t('faturamentos:edit.validation.invoiceNumber'),
                    showCloseButton: true,
                });
                return;
            }

            if(!this.state.data_emissao) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>{t('common:alert.attention')}</p>,
                    text: t('faturamentos:edit.validation.issueDate'),
                    showCloseButton: true,
                });
                return;
            }

            if(!this.state.data_vencimento) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>{t('common:alert.attention')}</p>,
                    text: t('faturamentos:edit.validation.dueDate'),
                    showCloseButton: true,
                });
                return;
            }

            if(!this.state.laboratorio_pagamento_forma_id) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>{t('common:alert.attention')}</p>,
                    text: t('faturamentos:edit.validation.paymentMethod'),
                    showCloseButton: true,
                });
                return;
            }

        }

        if (this.state.pago) {
            
            if(!this.state.data_pagamento) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>{t('common:alert.attention')}</p>,
                    text: t('faturamentos:edit.validation.paymentDate'),
                    showCloseButton: true,
                });
                return;
            }

            if(!this.state.pagamento_comprovante) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>{t('common:alert.attention')}</p>,
                    text: t('faturamentos:edit.validation.receipt'),
                    showCloseButton: true,
                });
                return;
            }

            if(!this.state.nota_comissao_numero) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>{t('common:alert.attention')}</p>,
                    text: t('faturamentos:edit.validation.commissionNote'),
                    showCloseButton: true,
                });
                return;
            }

            if(!this.state.pagamento_forma_id) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>{t('common:alert.attention')}</p>,
                    text: t('faturamentos:edit.validation.paymentMethodUsed'),
                    showCloseButton: true,
                });
                return;
            }

            if(this.state.pagamento_forma_id && this.state.pagamento_forma_id != this.state.laboratorio_pagamento_forma_id && !this.state.pagamento_motivo_alteracao) {
                MySwal.fire({
                    icon: 'warning',
                    title: <p>{t('common:alert.attention')}</p>,
                    text: t('faturamentos:edit.validation.paymentChangeReason'),
                    showCloseButton: true,
                });
                return;
            }
            
        }
    
        const formData = new FormData();
    
        this.setState({
            loading: true,
        });
    
        if (this.state.nota_upload) {
            formData.append('nota', this.state.nota_upload);
            formData.append('nota_fiscal_status', 'analise');
        } else {
            if (this.state.nota_fiscal_status) {
                formData.append('nota_fiscal_status', this.state.nota_fiscal_status);
            }
        }       
    
        if (this.state.data_pagamento) {
            formData.append('data_pagamento', this.state.data_pagamento);
        }
    
        formData.append('pago', this.state.pago);

        if (this.state.pagamento_forma_id) {
            formData.append('pagamento_forma_id', this.state.pagamento_forma_id);
        }

        if (this.state.pagamento_comprovante) {
            formData.append('pagamento_comprovante', this.state.pagamento_comprovante);
        }
        
        if (this.state.nota_fiscal_motivo_recusa) {
            formData.append('nota_fiscal_motivo_recusa', this.state.nota_fiscal_motivo_recusa);
        }
        if (this.state.nota_fiscal_numero) {
            formData.append('nota_fiscal_numero', this.state.nota_fiscal_numero);
        }
        if (this.state.data_vencimento) {
            formData.append('data_vencimento', this.state.data_vencimento);
        }
        if (this.state.data_emissao) {
            formData.append('data_emissao', this.state.data_emissao);
        }
        if (this.state.boleto_pagamento) {
            formData.append('boleto_pagamento', this.state.boleto_pagamento);
        }
        if (this.state.pagamento_banco) {
            formData.append('pagamento_banco', this.state.pagamento_banco);
        }
        if (this.state.pagamento_agencia) {
            formData.append('pagamento_agencia', this.state.pagamento_agencia);
        }
        if (this.state.pagamento_conta) {
            formData.append('pagamento_conta', this.state.pagamento_conta);
        }
        if (this.state.pagamento_tipo_conta) {
            formData.append('pagamento_tipo_conta', this.state.pagamento_tipo_conta);
        }
        if (this.state.pagamento_titular) {
            formData.append('pagamento_titular', this.state.pagamento_titular);
        }
        if (this.state.pagamento_chave_pix) {
            formData.append('pagamento_chave_pix', this.state.pagamento_chave_pix);
        }
        if (this.state.pagamento_url_cartao_credito) {
            formData.append('pagamento_url_cartao_credito', this.state.pagamento_url_cartao_credito);
        }
        if (this.state.pagamento_motivo_alteracao) {
            formData.append('pagamento_motivo_alteracao', this.state.pagamento_motivo_alteracao);
        }
        if (this.state.nota_comissao_numero) {
            formData.append('nota_comissao_numero', this.state.nota_comissao_numero);
        }

        if (this.state.laboratorio_pagamento_forma_id) {
            formData.append('laboratorio_pagamento_forma_id', this.state.laboratorio_pagamento_forma_id);
        }
    
        // Envia para API
        api({
            method: 'put',
            url: '/faturamento/' + this.state.id + '/',
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal);
    
            this.setState({
                loading: false,
            });
    
            MySwal.fire({
                title: <p>{t('faturamentos:edit.success.updated')}</p>,
                icon: 'success',
                showCloseButton: true,
            }).then((result) => {
                window.location.reload();
            });             
        })
        .catch(error => {
            let erro_msg = t('faturamentos:edit.errors.save');            
    
            if (error.response && error.response.status === 500) {
                erro_msg = t('faturamentos:errors.server');
            }
    
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            });
    
            this.setState({
                loading: false,
            });
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        
        if (name === "valor" || name === "valor_servico_atendimento") {
            const valorFormatado = formatarValor(value);
            this.setState({ [name]: valorFormatado });
        } 
        else if(name == 'pago'){
            this.setState({
                pago: e.target.checked,
            })
        }
        else if(name == 'laboratorio_pagamento_forma_id'){
            const objForma = this.state.formasPagamento.find(obj => obj.id == value);

            let formaSelecionada = {}
            if(objForma){
                formaSelecionada = objForma
            }

            this.setState({ 
                laboratorio_pagamento_forma_id: value,
                forma_atendimento_lab_selecionada: formaSelecionada
            });
        }
        else {
            this.setState({ [name]: value });
        }
    };

    onChangeArquivo = (e) => {
        if (e.target.files && e.target.files[0]) {
            const nota_upload = e.target.files[0];
            
            // Armazena o arquivo para upload
            this.setState({ nota_upload: nota_upload, nota_fiscal_numero: "" });
        }
    };

    carregarFormasPagamento = async () => {
        try {
            const response = await api.get('/formas-pagamento/');
            const formasPagamento = response.data.results.map(formaPagamento => ({
                id: formaPagamento.id,
                nome: formaPagamento.nome,
                slug: formaPagamento.slug,
            }));
            this.setState({ formasPagamento });
        } catch (error) {
            console.error('Erro ao carregar formas de pagamento:', error);
        }
    };

    handleFormaPagamentoChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleComprovanteChange = (e) => {
        const file = e.target.files[0];
    
        if (file && file.type !== "application/pdf") {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: <p>{this.props.t('faturamentos:edit.errors.invalidFile')}</p>,
                text: this.props.t('faturamentos:edit.errors.invalidFileText'),
                showCloseButton: true,
            });
            return;
        }
        this.setState({ pagamento_comprovante: file });
        if (file) {
            const url = URL.createObjectURL(file);
            this.setState({ pagamento_comprovante_url: url });
        }
    };

    handleNotaStatusChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleNotaRecusaChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleNotaNumeroChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleTipoPagamentoChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleBoletoChange = (e) => {
        const file = e.target.files[0];
    
        if (file && file.type !== "application/pdf") {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: <p>{this.props.t('faturamentos:edit.errors.invalidFile')}</p>,
                text: this.props.t('faturamentos:edit.errors.invalidFileText'),
                showCloseButton: true,
            });
            return;
        }
        this.setState({ boleto_pagamento: file });
        if (file) {
            const url = URL.createObjectURL(file);
            this.setState({ boleto_pagamento_url: url });
        }
    }

    handleTransferenciasChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    carregarServicos =  (atendimentoId) => {
        if (this.state.servicosPorAtendimento[atendimentoId]) {
            return;
        }

        api.get(`/atendimentos/servicos/?atendimento_id=${atendimentoId}`)
            .then((response) => {
                const servicos = Array.isArray(response.data.results) ? response.data.results : [];
                this.setState((prevState) => ({
                    servicosPorAtendimento: {
                        ...prevState.servicosPorAtendimento,
                        [atendimentoId]: servicos, 
                    },
                }));
            })
            .catch((error) => {
                console.error("Erro ao carregar serviços:", error);
            });
    };

    getLogsFaturamento = async () => {
        await api.get(`/logs/?faturamento_id=${this.state.id}`)
        .then(response => {
            this.setState({ 
                logs_faturamento: response.data.results,
            });
        })
        .catch(error => {
            console.error('Erro ao carregar logs do faturamento:', error);
            Sentry.captureException('Erro ao carregar logs do faturamento:', error);                                
        });
    }

    excluirServicoAtendimento = (servico) => {
        const { t } = this.props;
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            icon: 'warning',
            title: <p>{t('common:alert.attention')}</p>,
            text: t('faturamentos:edit.confirm.removeService', { nome: servico.servico_procedimento__nome, id: servico.id }),
            showCloseButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                api.put(`/atendimentos/servicos/${servico.id}/`, {
                    excluir_faturamento: true,
                })
                .then(response => {
                    MySwal.fire({
                        icon: 'success',
                        title: <p>{t('faturamentos:edit.success.serviceRemoved')}</p>,
                        showCloseButton: true,
                    }).then((result) => {
                        window.location.reload();
                    });
                })
                .catch(error => {
                    console.error('Erro ao excluir serviço do faturamento:', error);
                });
            }
        });
    }

    abrirModalAlteracaoData = (servico) => {
        const dataServico = servico.data || servico.agendamento__data_realizacao || '';
        this.setState({
            showModalAlteracaoData: true,
            id_servico_data: servico.id,
            data_servico_edicao: dataServico ? dataServico.substring(0, 16) : '',
        });
    }

    enviaRegistroAlteracaoData = (e) => {
        e.preventDefault();
        const { t } = this.props;

        const MySwal = withReactContent(Swal);

        if (!this.state.data_servico_edicao) {
            MySwal.fire({
                icon: 'error',
                title: <p>{t('common:alert.attention')}</p>,
                text: t('faturamentos:edit.validation.dateRequired'),
                showCloseButton: true,
            });
            return;
        }

        MySwal.fire({
            title: <p>{t('faturamentos:edit.confirm.changeDate')}</p>,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('common:label.yes'),
            cancelButtonText: t('common:label.no'),
            showCloseButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loading: true });

                api.put(`/atendimentos/servicos/${this.state.id_servico_data}/`, {
                    data: this.state.data_servico_edicao,
                })
                .then(response => {
                    this.setState({
                        loading: false,
                        showModalAlteracaoData: false,
                    });

                    MySwal.fire({
                        title: <p>{t('faturamentos:edit.success.dateChanged')}</p>,
                        icon: 'success',
                        showCloseButton: true,
                    }).then(() => {
                        window.location.reload();
                    });
                })
                .catch(error => {
                    let erro_msg = t('faturamentos:edit.errors.changeDate');

                    if (error.response && error.response.status === 500) {
                        erro_msg = t('faturamentos:errors.server');
                    }

                    MySwal.fire({
                        icon: 'error',
                        showCloseButton: true,
                        title: <p>{erro_msg}</p>,
                    });

                    this.setState({ loading: false });
                });
            }
        });
    }

    handleSelectTab = async (aba) => {
        if (this.state.carregamentoAbas.length > 0) {
            const containsAba = this.state.carregamentoAbas.some(item => item.nome === aba);
            if(containsAba){
                return;
            }
        }

        this.setState({
            loading: true
        });
        
        try {
            // Executa as requisições de forma assíncrona
            switch (aba) {

                case "logsFaturamento":
                    await this.getLogsFaturamento();
                    break;
    
                default:
                    break;
            }
    
            // Após todas as funções terminarem com sucesso, define loading como false
            this.setState({
                loading: false
            });

            this.setState(prevState => ({
                ...prevState,
                carregamentoAbas: [
                    ...prevState.carregamentoAbas,  // espalha os itens existentes
                    { nome: aba, status: true }     // adiciona o novo item ao final
                ]
            }));
    
        } catch (error) {
            // Caso algum erro aconteça, define loading como false
            console.error("Erro ao carregar os dados:", error);
            this.setState({
                loading: false
            });
        }
    }

    /**
     * Serviço e despesa discriminados na fatura. A NF é emitida sobre o serviço; a despesa é
     * reembolsada pelos comprovantes, então os dois números precisam aparecer separados.
     *
     * Soma linha a linha o que o backend já discriminou: `servicos` é o serviço puro, `despesas`
     * tudo que foi lançado nos agendamentos e `faturado` o total da OS (a NF). A despesa que
     * não entrou na NF — por regra do programa ou por ter sido lançada depois do faturamento —
     * é `foraDoFaturado`, e o total geral é sempre serviços + despesas.
     */
    totaisDiscriminadosFatura = () => {
        const itens = this.state.lista_atendimentos || [];
        const num = (v) => parseFloat(v || 0);
        const despesas = itens.reduce((soma, item) => soma + num(item.despesas_total), 0);
        const servicos = itens.reduce((soma, item) => soma + num(item.valor_servico ?? item.valor_atendimento ?? item.valor), 0);
        //quanto da despesa está embutido no valor faturado de cada linha
        const embutidas = itens.reduce((soma, item) => soma + Math.max(num(item.valor) - num(item.valor_servico ?? item.valor), 0), 0);
        const faturado = num(this.state.valor_total);
        const somadas = !itens.some(item => item.despesas_somadas === false);

        return {
            despesas,
            servicos,
            faturado,
            somadas,
            foraDoFaturado: Math.max(despesas - embutidas, 0),
            total: servicos + despesas,
        };
    }


    //retorna o(s) codigo(s) de voucher utilizados no atendimento informado
    getVoucherAtendimento = (atendimentoId) => {
        if (!atendimentoId || !this.state.dados_vouchers || this.state.dados_vouchers.length === 0) {
            return null;
        }

        const itens = this.state.dados_vouchers.filter(v => String(v.atendimento_id) === String(atendimentoId));
        if (itens.length === 0) {
            return null;
        }

        return itens.map(v => v.voucher__codigo).join(', ');
    };

    renderVoucherCell = (atendimentoId) => {
        const codigo = this.getVoucherAtendimento(atendimentoId);
        return (
            <td>
                {codigo
                    ? <span className="badge bg-success" style={{ letterSpacing: '1px' }}>{codigo}</span>
                    : '-'}
            </td>
        );
    };

    render(){
        const { t } = this.props;
        const dados_usuario = getCurrentUser();
        const statusLabel = this.state.nota_fiscal_status ? (this.statusConfig[this.state.nota_fiscal_status] || this.statusConfig['analise']) : this.statusConfig['analise'];
        const currentDate = new Date().toISOString().split('T')[0];

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina && t(this.state.titulo_pagina)}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosFaturamento" id="tabs-faturamento" className="aditus-tabs" onSelect={this.handleSelectTab}>
                    <Tab eventKey="dadosFaturamento" title={t('faturamentos:edit.tabs.data')}>
                        <Card className="cardDestaque">
                            <Card.Body>    
                                <h4>{t('faturamentos:edit.data.title')}</h4>
                                <Form onSubmit="">
                                    <Row>  
                                        <Col sm={6} xs={12}>
                                            <label>{t('faturamentos:edit.data.os')} </label>
                                            <span>
                                                {this.state.id} –{' '}
                                                <Badge className={this.state.cancelado ? 'bg-danger' : 'bg-info'}>
                                                    {this.state.cancelado ? t('faturamentos:edit.data.canceled') : t('faturamentos:edit.data.active')}
                                                </Badge>
                                            </span>
                                        </Col>                       
                                        <Col sm={6} xs={12}>
                                            <label>{t('faturamentos:edit.data.sentDate')} </label>
                                            <span> {formataDataHoraExibicao(this.state.data_envio)}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>{t('faturamentos:edit.data.startDate')} </label>
                                            <span> {formataDataHoraExibicao(this.state.data_inicio)}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>{t('faturamentos:edit.data.endDate')} </label>
                                            <span> {formataDataHoraExibicao(this.state.data_fim)}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>{t('faturamentos:edit.data.provider')} </label>
                                            <span> {this.state.dados_laboratorio.nome} (CNPJ: <b>{formataCNPJ(this.state.dados_laboratorio.cpf_cnpj)}</b>)</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>{t('faturamentos:edit.data.program')} </label>
                                            <span> {this.state.dados_programa.nome}</span>
                                        </Col>   
                                        <Col sm={6} xs={12}>
                                            <label>{t('faturamentos:edit.data.value')} </label>
                                            <span> {parseFloat(this.state.valor_total).toLocaleString(idiomaAtual(), {style: 'currency',currency: 'BRL'})}</span>
                                            {this.state.faturamento_credito_antecipacao && (
                                                <span>
                                                    <span className="text-danger"> <b>{t('faturamentos:edit.data.advanceCredit')}</b></span>
                                                </span>
                                            )}
                                        </Col>
                                        {/* a NF é emitida sobre o serviço; a despesa é reembolsada
                                            pelos comprovantes, então os dois vão separados */}
                                        {(() => {
                                            const totais = this.totaisDiscriminadosFatura();

                                            if (!totais.despesas) return null;

                                            const moeda = (v) => parseFloat(v || 0).toLocaleString(idiomaAtual(), {style: 'currency', currency: 'BRL'});

                                            return (
                                                <Col sm={12} xs={12}>
                                                    <label>{t('faturamentos:edit.data.composition')} </label>
                                                    <span> {t('faturamentos:edit.data.compositionParts', { servicos: moeda(totais.servicos), despesas: moeda(totais.despesas) })} = <strong>{moeda(totais.total)}</strong></span>
                                                    <small className="text-muted d-block">
                                                        {totais.somadas
                                                            ? t('faturamentos:edit.data.expensesIncluded')
                                                            : t('faturamentos:edit.data.expensesSeparate')}
                                                        {totais.somadas && totais.foraDoFaturado > 0 && (
                                                            <> {t('faturamentos:edit.data.expensesOutside', { valor: moeda(totais.foraDoFaturado) })}</>
                                                        )}
                                                    </small>
                                                </Col>
                                            );
                                        })()}
                                        {this.state.tipo_usuario !== 'prestador' && (
                                        <Col sm={6} xs={12}>
                                            <label>{t('faturamentos:edit.data.adminFee')} </label>
                                            {this.state.taxa_administrativa_valor && (
                                            <span>
                                                &nbsp;{this.state.taxa_administrativa_valor 
                                                ? parseFloat(this.state.taxa_administrativa_valor).toLocaleString(idiomaAtual(), { style: 'currency', currency: 'BRL' })
                                                : ''}
                                            &nbsp;({this.state.taxa_administrativa 
                                                ? parseFloat(this.state.taxa_administrativa).toLocaleString(idiomaAtual())
                                                : ''}%)
                                            </span>
                                            )}
                                        </Col>
                                        )}

                                        <Col sm={6} xs={12}>
                                            <label>{t('faturamentos:edit.data.paid')} </label>
                                            <span> {this.state.pago ? t('common:label.yes') : t('common:label.no')}</span>
                                        </Col>
                                        {this.state.pago && this.state.data_pagamento && (
                                        <Col sm={6} xs={12}>
                                            <label>{t('faturamentos:edit.data.paymentDate')} </label>
                                            <span> {this.state.data_pagamento ? formataDataHoraExibicao(this.state.data_pagamento) : '---'}</span>                                        
                                        </Col>
                                        )}
                                        {this.state.nota && this.state.nota_fiscal_status && (
                                        <Col sm={6} xs={12}>
                                            <label>{t('faturamentos:edit.data.nfStatus')} </label>
                                            <span
                                                style={{
                                                    backgroundColor: statusLabel.background,
                                                    color: statusLabel.color,
                                                    padding: '5px 10px',
                                                    fontSize: '12px',
                                                    borderRadius: '5px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    display: 'inline-block',
                                                    marginLeft: '10px'
                                                }}
                                            >
                                                {statusLabel.icon}
                                                <span style={{ marginLeft: '5px' }}>{t(statusLabel.text)}</span>
                                            </span>
                                        </Col>
                                        )}  
                                        {!this.state.nota && (
                                            <Col sm={6} xs={12}>
                                                <label>{t('faturamentos:edit.data.nfStatus')} </label>
                                                <span
                                                    style={{
                                                        backgroundColor: statusLabel.background,
                                                        color: statusLabel.color,
                                                        padding: '5px 10px',
                                                        fontSize: '12px',
                                                        borderRadius: '5px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        display: 'inline-block',
                                                        marginLeft: '10px'
                                                    }}
                                                >
                                                    {statusLabel.icon}
                                                    <span style={{ marginLeft: '5px' }}>{t('faturamentos:nfStatus.aguardando')}</span>
                                                </span>
                                            </Col>
                                        )}                      
                                    </Row>
                                    {this.state.ordem_pagamento && (
                                    <>
                                        <Row className="mt-3 mb-3">
                                            <Col sm={12} xs={12}>
                                                <label>{t('faturamentos:edit.data.paymentOrder')} </label>
                                                <span> {this.state.ordem_pagamento ? this.state.ordem_pagamento : '---'}</span>                      
                                            </Col>
                                        </Row>
                                    </>
                                    )}
                                    {this.state.nota_fiscal_status === "recusado" && this.state.nota_fiscal_motivo_recusa_banco && (
                                    <>
                                        <Row className="mt-3 mb-3">
                                            <Col sm={12} xs={12}>
                                                <Alert className="alert-warning">
                                                    <label><FaExclamationCircle /> {t('faturamentos:edit.data.rejectionReason')} </label>
                                                    <span> {this.state.nota_fiscal_motivo_recusa ? this.state.nota_fiscal_motivo_recusa : '---'}</span>               
                                                </Alert>                   
                                            </Col>
                                        </Row>
                                    </>
                                    )}
                                </Form>
                            </Card.Body>
                        </Card>
                        <Card className="cardDestaque mt-3">
                            <Card.Body>       
                                <h4>{t('faturamentos:edit.fiscal.title')}</h4>
                                <Form onSubmit={this.enviaRegistro}>
                                    <Row className="mt-4">  
                                        {(this.state.tipo_usuario === "prestador" || this.state.tipo_usuario === 'gestor' || this.state.is_superuser) ? (                               
                                        <Col sm={6} xs={12}>
                                            <Form.Group>
                                                <Form.Label>{t('faturamentos:edit.fiscal.invoice')}</Form.Label>
                                                {
                                                (!this.state.nota || this.state.nota_fiscal_status === "recusado") && 
                                                    <Form.Control 
                                                        type="file" 
                                                        name="nota_upload" 
                                                        onChange={this.onChangeArquivo} 
                                                        ref={this.fileInput} 
                                                    />
                                                } 
                                            </Form.Group>
                                            {this.state.nota && (
                                                <a className="btn btn-secondary btn-sm mt-2" href={this.state.nota} target="_blank">
                                                    <FaFile /> {t('faturamentos:edit.fiscal.viewInvoice')}
                                                </a>
                                            )}
                                        </Col>
                                        ) : (
                                        <Col sm={6} xs={12}>
                                            <Form.Group>
                                                <Form.Label>{t('faturamentos:edit.fiscal.invoice')}</Form.Label>
                                            </Form.Group>
                                            {this.state.nota ? (
                                                <a className="btn btn-secondary btn-sm mt-2" href={this.state.nota} target="_blank">
                                                    <FaFile /> {t('faturamentos:edit.fiscal.viewInvoice')}
                                                </a>
                                            ) : (
                                                <p>{t('faturamentos:edit.fiscal.awaitingInvoice')}</p>
                                            )}
                                        </Col>
                                        )}

                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{t('faturamentos:edit.fiscal.invoiceNumber')}</Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    name="nota_fiscal_numero" 
                                                    value={this.state.nota_fiscal_numero} 
                                                    onChange={this.handleNotaNumeroChange} 
                                                    placeholder={t('faturamentos:edit.fiscal.invoiceNumberPlaceholder')}
                                                    disabled={this.state.pago}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{t('faturamentos:edit.fiscal.issueDate')}</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    required
                                                    placeholder={t('faturamentos:edit.fiscal.issueDate')}
                                                    name="data_emissao" 
                                                    value={this.state.data_emissao} 
                                                    onChange={this.handleChange} 
                                                    disabled={this.state.pago}
                                                />    
                                            </Form.Group>
                                        </Col>

                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{t('faturamentos:edit.fiscal.dueDate')}</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    required
                                                    placeholder={t('faturamentos:edit.fiscal.dueDate')}
                                                    name="data_vencimento" 
                                                    value={this.state.data_vencimento} 
                                                    onChange={this.handleChange} 
                                                    min={currentDate}
                                                    disabled={this.state.pago}
                                                />    
                                            </Form.Group>
                                        </Col>

                                        {this.state.tipo_usuario !== "prestador" && this.state.nota && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>{t('faturamentos:edit.fiscal.approval')}</Form.Label>
                                                    <Form.Control 
                                                        as="select" 
                                                        name="nota_fiscal_status" 
                                                        value={this.state.nota_fiscal_status} 
                                                        disabled={this.state.pago}
                                                        required 
                                                        onChange={this.handleNotaStatusChange}>
                                                        <option value="">{t('faturamentos:edit.fiscal.approvalPlaceholder')}</option>
                                                        {Object.entries(aprovacaoNota).map(([sigla, nome]) => (
                                                            <option key={sigla} value={sigla}>{t(`faturamentos:nfStatus.${sigla}`, { defaultValue: nome })}</option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {this.state.tipo_usuario !== "prestador" && this.state.nota_fiscal_status === "recusado" && (
                                            <Col sm={12} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>{t('faturamentos:edit.fiscal.rejectionReason')}</Form.Label>
                                                    <Form.Control 
                                                        as="textarea" 
                                                        name="nota_fiscal_motivo_recusa" 
                                                        value={this.state.nota_fiscal_motivo_recusa} 
                                                        onChange={this.handleNotaRecusaChange} 
                                                        placeholder={t('faturamentos:edit.fiscal.rejectionPlaceholder')} 
                                                        rows={3} 
                                                        required 
                                                    />
                                                </Form.Group>
                                            </Col>
                                        )}
                                    </Row>
                                
                                <hr></hr>

                                <h4 className="mt-4">{t('faturamentos:edit.payment.title')}</h4>
                                    {this.state.tipo_usuario !== "prestador" ? (
                                        <Row className="mt-2">
                                            {this.state.nota_fiscal_status === "aprovado" && (
                                                <>
                                                    <Col sm={4} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>{t('faturamentos:edit.payment.status')}</Form.Label>
                                                            <Form.Check 
                                                                type="switch" 
                                                                name="pago" 
                                                                id="pago" 
                                                                label={t('faturamentos:edit.payment.paid')}
                                                                disabled={this.state.pago_banco}
                                                                value="1" 
                                                                checked={this.state.pago ? true : false} 
                                                                onChange={this.handleChange} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    {this.state.pago && (
                                                    <Col sm={4} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>{t('faturamentos:edit.payment.date')}</Form.Label>
                                                            <Form.Control
                                                                type="datetime-local"
                                                                name="data_pagamento"
                                                                placeholder={t('faturamentos:edit.payment.datePlaceholder')}
                                                                value={this.state.data_pagamento || ''} 
                                                                onChange={this.handleChange} 
                                                                disabled={this.state.pago_banco}
                                                            />    
                                                        </Form.Group>
                                                    </Col>
                                                    )}
                                                </>
                                            )}
                                            {this.state.pago && (
                                                <>
                                                    <Col sm={4} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>{t('faturamentos:edit.payment.receipt')}</Form.Label>
                                                            {!this.state.pago_banco && (
                                                            <Form.Control 
                                                                type="file" 
                                                                name="pagamento_comprovante" 
                                                                accept="application/pdf" 
                                                                placeholder={t('faturamentos:edit.payment.receiptPlaceholder')} 
                                                                onChange={this.handleComprovanteChange} 
                                                                ref={this.fileInput} 
                                                            />
                                                            )}
                                                        </Form.Group>
                                                        {this.state.pagamento_comprovante_url && (
                                                            <a className="btn btn-secondary btn-sm mb-3" href={this.state.pagamento_comprovante_url} target="_blank">
                                                                <FaFile /> {t('faturamentos:edit.payment.viewReceipt')}
                                                            </a>
                                                        )}
                                                    </Col>
                                                <Row>
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>{t('faturamentos:edit.payment.commissionNote')}</Form.Label>
                                                            <Form.Control 
                                                                as="textarea" 
                                                                name="nota_comissao_numero" 
                                                                value={this.state.nota_comissao_numero} 
                                                                onChange={this.handleChange} 
                                                                rows={1} 
                                                                disabled={this.state.pago_banco} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>{t('faturamentos:edit.payment.method')}</Form.Label>
                                                            <Form.Control 
                                                                as="select" 
                                                                name="pagamento_forma_id" 
                                                                disabled={this.state.pago_banco}
                                                                onChange={this.handleFormaPagamentoChange} 
                                                                value={this.state.pagamento_forma_id || ''}>
                                                                <option value="">{t('faturamentos:edit.payment.methodUsedPlaceholder')}</option>
                                                                {this.state.formasPagamento && this.state.formasPagamento.map((formaPagamento) => (
                                                                    <option key={formaPagamento.id} value={formaPagamento.id}>
                                                                        {formaPagamento.nome}
                                                                    </option>
                                                                ))}
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Col>
                                                    {this.state.pagamento_forma_id && this.state.pagamento_forma_id != this.state.laboratorio_pagamento_forma_id && (
                                                        <Col sm={12} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>{t('faturamentos:edit.payment.changeReason')}</Form.Label>
                                                                <Form.Control 
                                                                    as="textarea" 
                                                                    name="pagamento_motivo_alteracao" 
                                                                    value={this.state.pagamento_motivo_alteracao} 
                                                                    onChange={this.handleChange} 
                                                                    placeholder={t('faturamentos:edit.payment.changeReasonPlaceholder')} 
                                                                    rows={3} 
                                                                    disabled={this.state.pago_banco}
                                                                    required 
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    )}
                                                </Row>
                                                </>
                                            )}
                                        </Row>
                                    ) : (                                
                                        <Row className="mt-2">
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>{t('faturamentos:edit.payment.chooseMethod')}</Form.Label>
                                                    <Form.Control 
                                                        as="select" 
                                                        name="laboratorio_pagamento_forma_id" 
                                                        disabled={this.state.pago_banco}
                                                        onChange={this.handleChange} 
                                                        value={this.state.laboratorio_pagamento_forma_id || ''}>
                                                        <option value="">{t('faturamentos:edit.payment.chooseMethodPlaceholder')}</option>
                                                        {this.state.formasPagamento && this.state.formasPagamento.map((formaPagamento) => (
                                                            <option key={formaPagamento.id} value={formaPagamento.id}>
                                                                {formaPagamento.nome}
                                                            </option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                            {this.state.pago && this.state.data_pagamento && (
                                                <Col sm={12} xs={12}>
                                                    <label>{t('faturamentos:edit.payment.paidOn')} </label>
                                                    <span> {formataDataHoraExibicao(this.state.data_pagamento)}</span>
                                                </Col>
                                            )}
                                            {this.state.pago && this.state.pagamento_comprovante_url && (
                                                <Col sm={12} xs={12}>
                                                    <a className="btn btn-secondary btn-sm mb-3" href={this.state.pagamento_comprovante_url} target="_blank">
                                                        <FaFile /> {t('faturamentos:edit.payment.viewReceipt')}
                                                    </a>
                                                </Col>
                                            )}
                                        </Row>
                                    )}
                                                                
                                    <Row className="mt-4">
                                        {
                                        this.state.forma_atendimento_lab_selecionada && this.state.forma_atendimento_lab_selecionada.slug == 'boleto' &&
                                        <Col sm={6} xs={12}>
                                            {this.state.tipo_usuario == "prestador" && !this.state.pago &&  (
                                            <Form.Group className="mb-3">
                                                <h6 className="mb-3">{t('faturamentos:edit.payment.boleto')}</h6>       
                                                <Form.Label>{t('faturamentos:edit.payment.pdfFile')}</Form.Label>
                                                <Form.Control 
                                                    type="file" 
                                                    name="boleto_pagamento" 
                                                    onChange={this.handleBoletoChange}
                                                    disabled={this.state.pago}
                                                />
                                            </Form.Group>
                                            )}
                                            
                                            {this.state.boleto_pagamento_url && (
                                                <>
                                                    {this.state.tipo_usuario !== 'prestador' && (
                                                        <h6 className="mb-3">{t('faturamentos:edit.payment.boleto')}</h6>
                                                    )}
                                                    <a className="btn btn-secondary btn-sm mb-3" href={this.state.boleto_pagamento_url} target="_blank">
                                                        <FaFile /> {t('faturamentos:edit.payment.viewBoleto')}
                                                    </a>
                                                </>
                                            )}
                                        </Col>
                                        }  

                                        {
                                        this.state.forma_atendimento_lab_selecionada && this.state.forma_atendimento_lab_selecionada.slug == 'cartao-de-credito' &&
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <h6 className="mb-3">{t('faturamentos:edit.payment.creditCard')}</h6>
                                                <Form.Label>{t('faturamentos:edit.payment.paymentLink')} </Form.Label>
                                                {this.state.tipo_usuario === 'prestador' ? (
                                                <Form.Control 
                                                    type="text" 
                                                    name="pagamento_url_cartao_credito" 
                                                    value={this.state.pagamento_url_cartao_credito} 
                                                    onChange={this.handleTransferenciasChange}
                                                    placeholder={t('faturamentos:edit.payment.paymentLinkPlaceholder')}
                                                    disabled={this.state.pago} 
                                                />
                                                ) : (
                                                    <a href={this.state.pagamento_url_cartao_credito} target="_blank">{this.state.pagamento_url_cartao_credito}</a>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        }  

                                        {
                                        this.state.forma_atendimento_lab_selecionada && this.state.forma_atendimento_lab_selecionada.slug == 'pix' &&
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <h6 className="mb-3">PIX</h6>
                                                <Form.Label>{t('faturamentos:edit.payment.pixKey')}</Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    name="pagamento_chave_pix" 
                                                    value={this.state.pagamento_chave_pix} 
                                                    onChange={this.handleTransferenciasChange}
                                                    placeholder={t('faturamentos:edit.payment.pixKeyPlaceholder')}
                                                    disabled={this.state.pago} 
                                                />
                                            </Form.Group>
                                        </Col>
                                        }                             

                                        {
                                        this.state.forma_atendimento_lab_selecionada && this.state.forma_atendimento_lab_selecionada.slug == 'transferencia-bancaria' &&
                                        <>
                                            <h6 className="mb-3">{t('faturamentos:edit.payment.transfer')}</h6>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>{t('faturamentos:edit.payment.bank')}</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="pagamento_banco" 
                                                        value={this.state.pagamento_banco} 
                                                        onChange={this.handleTransferenciasChange}
                                                        placeholder={t('faturamentos:edit.payment.bankPlaceholder')}
                                                        disabled={this.state.pago} 
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>{t('faturamentos:edit.payment.branch')}</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="pagamento_agencia" 
                                                        value={this.state.pagamento_agencia} 
                                                        onChange={this.handleTransferenciasChange}
                                                        placeholder={t('faturamentos:edit.payment.branchPlaceholder')} 
                                                        disabled={this.state.pago}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>{t('faturamentos:edit.payment.accountType')}</Form.Label>
                                                    <Form.Control 
                                                        as="select" 
                                                        name="pagamento_tipo_conta"
                                                        disabled={this.state.pago} 
                                                        value={this.state.pagamento_tipo_conta} 
                                                        onChange={this.handleTransferenciasChange}>
                                                        <option value="corrente">{t('faturamentos:edit.payment.checking')}</option>
                                                        <option value="poupanca">{t('faturamentos:edit.payment.savings')}</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>{t('faturamentos:edit.payment.account')}</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="pagamento_conta" 
                                                        value={this.state.pagamento_conta} 
                                                        onChange={this.handleTransferenciasChange}
                                                        placeholder={t('faturamentos:edit.payment.accountPlaceholder')}
                                                        disabled={this.state.pago} 
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>{t('faturamentos:edit.payment.holder')}</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="pagamento_titular" 
                                                        value={this.state.pagamento_titular} 
                                                        onChange={this.handleTransferenciasChange}
                                                        placeholder={t('faturamentos:edit.payment.holderPlaceholder')}
                                                        disabled={this.state.pago} 
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </>
                                        }
                                    </Row>
                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning" className="mt-3">
                                        {t(this.state.erroLoadRegistro)}
                                    </Alert> : ''
                                    }

                                    {this.state.tipo_usuario === 'prestador' ? (
                                        <>
                                        {(this.state.nota_fiscal_status === 'recusado' || (!this.state.nota && !this.state.pago)) && (
                                            <Button variant="success" type="submit" className="btn-submit mt-4 mb-3" disabled={this.state.loading}>
                                                {this.state.loading ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : (
                                                    <>
                                                        <FaCheck className="me-1" /> {t('common:button.save')}
                                                    </>
                                                )}
                                            </Button>
                                        )}
                                        </>
                                    ) : (
                                        <>
                                        {!this.state.pago_banco && (
                                            <Button variant="success" type="submit" className="btn-submit mt-4 mb-3" disabled={this.state.loading}>
                                                {this.state.loading ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : (
                                                    <>
                                                        <FaCheck className="me-1" /> {t('common:button.save')}
                                                    </>
                                                )}
                                            </Button>
                                        )}
                                        </>
                                    )}
                                </Form> 
                            </Card.Body>                
                        </Card>

                        <Card className="cardDestaque mt-3">
                            <Card.Body>
                                { this.state.faturamento_credito_antecipacao ? (
                                    <h4>{t('faturamentos:edit.items.advanceCredit')}</h4>
                                ) : (
                                    <h4>{this.state.dados_programa.tipo_faturamento === 'atendimento' ? t('faturamentos:edit.items.relatedEncounters') : t('faturamentos:edit.items.relatedServices')}</h4>
                                )}
                                
                                <Table responsive className="custom-table">
                                    {!this.state.faturamento_credito_antecipacao ?  (
                                        this.state.dados_programa.tipo_faturamento === 'atendimento' ? (
                                            <thead>
                                                <tr>                                    
                                                    <th>{t('faturamentos:edit.items.encounterId')}</th>
                                                    <th>{t('faturamentos:edit.items.date')}</th>                                    
                                                    <th>{t('faturamentos:edit.items.patientId')}</th>
                                                    <th>{t('faturamentos:edit.items.value')}</th>
                                                    {this.state.dados_programa?.habilitar_vouchers && <th>{t('faturamentos:edit.items.voucher')}</th>}
                                                    <th></th>
                                                </tr>
                                            </thead>
                                        ) : (
                                            <thead>
                                                <tr>                                    
                                                    <th>{t('faturamentos:edit.items.serviceId')}</th>
                                                    <th>{t('faturamentos:edit.items.encounterIdFull')}</th>
                                                    <th>{t('faturamentos:edit.items.service')}</th>
                                                    <th>{t('faturamentos:edit.items.date')}</th>                                    
                                                    <th>{t('faturamentos:edit.items.patientId')}</th>
                                                    <th>{t('faturamentos:edit.items.patientName')}</th>
                                                    <th>{t('faturamentos:edit.items.value')}</th>
                                                    {this.state.dados_programa?.habilitar_vouchers && <th>{t('faturamentos:edit.items.voucher')}</th>}
                                                    <th></th>
                                                </tr>
                                            </thead>
                                        )
                                    ) : (
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>{t('faturamentos:edit.items.service')}</th>
                                                <th>{t('faturamentos:edit.items.date')}</th>
                                                <th>{t('faturamentos:edit.items.provider')}</th>
                                                <th>{t('faturamentos:edit.items.value')}</th>
                                                <th>{t('faturamentos:edit.items.quantity')}</th>
                                                <th>{t('faturamentos:edit.items.totalValue')}</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                    )}
                                    <tbody>
                                        {this.state.lista_atendimentos.map((item, index) => (
                                            this.state.dados_programa.tipo_faturamento === 'atendimento' ? (
                                                <React.Fragment key={item.id}>  
                                                    <tr>
                                                        <td>{item.atendimento__id || item.id}</td>
                                                        <td>{formataDataHoraExibicao(item.data)}</td>                                    
                                                        <td>{item.beneficiario_id || item.atendimento__beneficiario_id}</td>
                                                        <td>
                                                            <strong>{parseFloat(item.valor_atendimento || item.valor).toLocaleString(idiomaAtual(), {style: 'currency',currency: 'BRL'})}</strong>
                                                            {this.state.nota_fiscal_status != 'aprovado' && !this.state.pago && dados_usuario['tipo_usuario'] != 'prestador' && (
                                                                <>
                                                                    <FaEdit className="ms-2" title={t('faturamentos:edit.items.edit')} style={{cursor: 'pointer'}} onClick={() => this.alterarValorServicoAtendimento(item.atendimento__id || item.id, 'atendimento', item.valor_atendimento || item.valor)} />
                                                                    {/*<FaTrash className="ms-2" title="Excluir" style={{cursor: 'pointer'}} onClick={() => this.excluirServicoAtendimento(item)} /> */}
                                                                </>
                                                            )}
                                                        </td>
                                                        {this.state.dados_programa?.habilitar_vouchers && this.renderVoucherCell(item.atendimento__id || item.id)}
                                                        <td className="text-end">
                                                        {/*<Button type="button" variant="outline-primary" size="sm" onClick={() => this.carregarServicos(item.id)}>
                                                            <FaFileInvoice /> Ver Serviços
                                                        </Button>*/}
                                                        </td>
                                                    </tr>
                                                </React.Fragment>     
                                            ) : (
                                                <React.Fragment key={item.id}>  
                                                    <tr>
                                                        <td>{item.id}</td>                                  
                                                        <td><a href={`/atendimentos/edit/${item.atendimento__uuid}`} target="_blank">{item.atendimento__id}</a></td>
                                                        <td>{item.servico_procedimento__nome}</td>
                                                        <td>
                                                            {formataDataHoraExibicao(item.data ? item.data : item.agendamento__data_realizacao)}
                                                            {this.state.nota_fiscal_status != 'aprovado' && !this.state.pago && dados_usuario['tipo_usuario'] != 'prestador' && (
                                                                <FaEdit className="ms-2" title={t('faturamentos:edit.items.editDate')} style={{cursor: 'pointer'}} onClick={() => this.abrirModalAlteracaoData(item)} />
                                                            )}
                                                        </td>
                                                        <td>{item.atendimento__beneficiario_id}</td>
                                                        <td>{item.atendimento__beneficiario__nome}</td>
                                                        <td><strong>{parseFloat(item.valor).toLocaleString(idiomaAtual(), {style: 'currency',currency: 'BRL'})}</strong>
                                                            {this.state.nota_fiscal_status != 'aprovado' && !this.state.pago && dados_usuario['tipo_usuario'] != 'prestador' && (
                                                                <>
                                                                    <FaEdit className="ms-2" title={t('faturamentos:edit.items.edit')} style={{cursor: 'pointer'}} onClick={() => this.alterarValorServicoAtendimento(item.id, 'servico', item.valor)} />
                                                                    <FaTrash className="ms-2" title={t('faturamentos:edit.items.remove')} style={{cursor: 'pointer'}} onClick={() => this.excluirServicoAtendimento(item)} />
                                                                </>
                                                            )}
                                                            {/* A despesa entra somada ao valor do serviço; sem discriminar,
                                                                o prestador não entende de onde vem o total da fatura. */}
                                                            {parseFloat(item.despesas_total || 0) > 0 && (
                                                                <div className="mt-1" style={{ fontSize: '12px', lineHeight: 1.5 }}>
                                                                    <div className="text-muted">
                                                                        {t('faturamentos:edit.items.serviceLabel')} {parseFloat(item.valor_servico || 0).toLocaleString(idiomaAtual(), {style: 'currency', currency: 'BRL'})}
                                                                    </div>
                                                                    {/* quando o programa não soma a despesa no serviço, ficar
                                                                        de fora do faturado é a regra — não é divergência */}
                                                                    <div className={(item.faturado_inclui_despesas || item.despesas_somadas === false) ? 'text-muted' : 'text-warning'}>
                                                                        {t('faturamentos:edit.items.expensesLabel')} {parseFloat(item.despesas_total).toLocaleString(idiomaAtual(), {style: 'currency', currency: 'BRL'})}
                                                                        {item.despesas_somadas === false
                                                                            ? ` (${t('faturamentos:edit.items.reimbursementNote')})`
                                                                            : (!item.faturado_inclui_despesas && ` (${t('faturamentos:edit.items.outsideBilledNote')})`)}
                                                                        <Button
                                                                            variant="link"
                                                                            className="p-0 ms-1 align-baseline"
                                                                            style={{ fontSize: '12px' }}
                                                                            onClick={() => this.setState({ detalheDespesasItem: item })}
                                                                        >
                                                                            {t('faturamentos:edit.items.detail')}
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </td>
                                                        {this.state.dados_programa?.habilitar_vouchers && this.renderVoucherCell(item.atendimento__id)}
                                                        <td className="text-end">
                                                        {/*<Button type="button" variant="outline-primary" size="sm" onClick={() => this.carregarServicos(item.id)}>
                                                            <FaFileInvoice /> Ver Serviços
                                                        </Button>*/}
                                                        </td>
                                                    </tr>
                                                </React.Fragment>     
                                            )
                                        ))}

                                        {this.state.dados_programa.tipo_faturamento === 'atendimento' && 
                                            this.state.lista_historico_atendimentos.map((item, index) => (
                                                <React.Fragment key={item.atendimento_id}>  
                                                <tr className="linha-cancelada">
                                                    <td>{item.atendimento_id}</td>
                                                    <td>{formataDataHoraExibicao(item.atendimento__data)}</td>                                    
                                                    <td>{item.atendimento__beneficiario_id}</td>
                                                    <td><strong>{parseFloat(item.atendimento__valor_atendimento).toLocaleString(idiomaAtual(), {style: 'currency',currency: 'BRL'})}</strong></td>
                                                    {this.state.dados_programa?.habilitar_vouchers && this.renderVoucherCell(item.atendimento_id)}
                                                    <td className="text-end">
                                                    {/*<Button type="button" variant="outline-primary" size="sm" onClick={() => this.carregarServicos(item.id)}>
                                                        <FaFileInvoice /> Ver Serviços
                                                    </Button>*/}
                                                </td>
                                            </tr>
                                            </React.Fragment>     
                                        ))}
                                        {this.state.dados_programa.tipo_faturamento === 'servico' && 
                                            this.state.lista_historico_atendimentos_servicos.map((item, index) => (
                                                <React.Fragment key={item.atendimento_id}>  
                                                <tr className="linha-cancelada">
                                                    <td>{item.atendimento_servico_id}</td>                                  
                                                    <td><a href={`/atendimentos/edit/${item.atendimento_servico__atendimento__uuid}`} target="_blank">{item.atendimento_servico__atendimento__id}</a></td>
                                                    <td>{item.atendimento_servico__servico_procedimento__nome}</td>
                                                    <td>{formataDataHoraExibicao(item.atendimento_servico__data)}</td>  
                                                    <td>{item.atendimento_servico__atendimento__beneficiario_id}</td>
                                                    <td><strong>{parseFloat(item.atendimento_servico__valor).toLocaleString(idiomaAtual(), {style: 'currency',currency: 'BRL'})}</strong></td>
                                                    {this.state.dados_programa?.habilitar_vouchers && this.renderVoucherCell(item.atendimento_servico__atendimento__id)}
                                                    <td className="text-end">
                                                    {/*<Button type="button" variant="outline-primary" size="sm" onClick={() => this.carregarServicos(item.id)}>
                                                        <FaFileInvoice /> Ver Serviços
                                                    </Button>*/}
                                                    </td>
                                                </tr>
                                            </React.Fragment>     
                                        ))}

                                        {this.state.faturamento_credito_antecipacao && (
                                            <React.Fragment>  
                                                <tr>
                                                    <td>{this.state.dados_credito_antecipacao[0].id}</td>                                  
                                                    <td>{this.state.dados_credito_antecipacao[0].servico_procedimento__nome}</td>
                                                    <td>{formataDataHoraExibicao(this.state.dados_credito_antecipacao[0].data_criacao)}</td>  
                                                    <td>{this.state.dados_credito_antecipacao[0].prestador__nome}</td>
                                                    <td><strong>{parseFloat(this.state.valor_total / this.state.dados_credito_antecipacao[0].quantidade).toLocaleString(idiomaAtual(), {style: 'currency',currency: 'BRL'})}</strong></td>
                                                    <td>{this.state.dados_credito_antecipacao[0].quantidade}</td>
                                                    <td>{parseFloat(this.state.valor_total).toLocaleString(idiomaAtual(), {style: 'currency',currency: 'BRL'})}</td>
                                                    <td className="text-end"></td>
                                                </tr>
                                            </React.Fragment>  
                                        )}

                                        <tr></tr>

                                        {/* a despesa (custo) precisa aparecer separada e entrar num total geral:
                                            o "Valor total faturado" é o da nota fiscal e, por regra do programa ou por ter
                                            sido lançada depois, a despesa pode não estar nele */}
                                        {(() => {
                                            const totais = this.totaisDiscriminadosFatura();

                                            if (!totais.despesas) return null;

                                            const colSpan = (!this.state.faturamento_credito_antecipacao && this.state.dados_programa.tipo_faturamento === 'atendimento') ? 3 : 6;
                                            const moeda = (v) => parseFloat(v || 0).toLocaleString(idiomaAtual(), {style: 'currency', currency: 'BRL'});

                                            return (
                                                <>
                                                    <tr>
                                                        <td colSpan={colSpan} align="right">{t('faturamentos:edit.items.servicesTotal')}</td>
                                                        <td>{moeda(totais.servicos)}</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={colSpan} align="right">
                                                            {totais.somadas ? t('faturamentos:edit.items.expensesTotal') : t('faturamentos:edit.items.expensesTotalReimbursement')}
                                                        </td>
                                                        <td>{moeda(totais.despesas)}</td>
                                                        <td></td>
                                                    </tr>
                                                </>
                                            );
                                        })()}

                                        {this.state.faturamento_credito_antecipacao ? (
                                            <tr className="table-primary">
                                                <td colSpan={6} align="right"><strong>{t('faturamentos:edit.items.billedTotal')}</strong> </td>
                                                <td><strong>{parseFloat(this.state.valor_total).toLocaleString(idiomaAtual(), {style: 'currency',currency: 'BRL'})}</strong></td>
                                                <td></td>
                                            </tr>
                                        ) : (
                                            <tr className="table-primary">
                                                <td colSpan={this.state.dados_programa.tipo_faturamento === 'atendimento' ? 3 : 6} align="right"><strong>{t('faturamentos:edit.items.billedTotal')}</strong> </td>
                                                <td><strong>{parseFloat(this.state.valor_total).toLocaleString(idiomaAtual(), {style: 'currency',currency: 'BRL'})}</strong></td>
                                                <td></td>
                                            </tr>
                                        )}

                                        {(() => {
                                            const totais = this.totaisDiscriminadosFatura();

                                            //só quando o total geral difere da NF; se a despesa já está toda no faturado, o "Valor total faturado" basta
                                            if (!totais.despesas || Math.abs(totais.total - totais.faturado) < 0.005) return null;

                                            const colSpan = (!this.state.faturamento_credito_antecipacao && this.state.dados_programa.tipo_faturamento === 'atendimento') ? 3 : 6;

                                            return (
                                                <tr className="table-primary">
                                                    <td colSpan={colSpan} align="right"><strong>{t('faturamentos:edit.items.grandTotal')}</strong> </td>
                                                    <td><strong>{parseFloat(totais.total).toLocaleString(idiomaAtual(), {style: 'currency',currency: 'BRL'})}</strong></td>
                                                    <td></td>
                                                </tr>
                                            );
                                        })()}
                                    </tbody>
                                </Table>                      
                            </Card.Body>
                        </Card>
                    </Tab>
                    {(this.state.id && (dados_usuario['tipo_usuario'] == 'operador' || dados_usuario['tipo_usuario'] == 'gestor' || dados_usuario['tipo_usuario'] == '')) && (
                    <Tab eventKey="logsFaturamento" title={t('faturamentos:edit.tabs.logs')}>
                        <Card className="cardDestaque">
                            <Card.Body>       
                                <h4><strong>{t('faturamentos:edit.logs.title')}</strong></h4>   

                                <Table responsive className="custom-table mt-3">
                                    <thead>
                                        <tr>
                                            <th>{t('faturamentos:edit.items.date')}</th>
                                            <th>{t('faturamentos:edit.logs.description')}</th>
                                            <th>{t('faturamentos:edit.logs.action')}</th>
                                            <th>{t('faturamentos:edit.logs.user')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                        this.state.logs_faturamento.map((item) =>
                                        <tr key={item.id}>
                                            <td>
                                                {formataDataHoraExibicao(item.action_time)}
                                            </td>
                                            <td>
                                                {item.change_message ? this.quebraLinhaHistorico(item.change_message) : item.object_repr}
                                            </td>
                                            <td>
                                                {item.action_flag}
                                            </td>
                                            <td>
                                                {item.user__first_name} {item.user__last_name}
                                            </td>
                                        </tr>
                                        )
                                        }                                                                                     
                                    </tbody>                                                                                
                                </Table>
                            </Card.Body>
                        </Card>
                    </Tab>
                    )}
                </Tabs>

                {/* Detalhe das despesas de um serviço faturado */}
                <Modal show={!!this.state.detalheDespesasItem} onHide={() => this.setState({ detalheDespesasItem: null })} centered>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ fontSize: '18px' }}>{t('faturamentos:edit.composition.title')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {(() => {
                            const item = this.state.detalheDespesasItem;
                            if (!item) return null;
                            const moeda = (v) => parseFloat(v || 0).toLocaleString(idiomaAtual(), { style: 'currency', currency: 'BRL' });

                            return (
                                <>
                                    <p className="mb-2">
                                        <strong>{item.servico_procedimento__nome}</strong>
                                        <span className="text-muted"> — {t('faturamentos:edit.composition.serviceNumber', { id: item.id })}</span>
                                    </p>
                                    <Table size="sm" className="custom-table mb-0">
                                        <tbody>
                                            <tr>
                                                <td>{t('faturamentos:edit.composition.service')}</td>
                                                <td className="text-end">{moeda(item.valor_servico)}</td>
                                            </tr>
                                            {(item.despesas_itens || []).map((d) => (
                                                <tr key={d.id}>
                                                    <td className="ps-4 text-muted">
                                                        {d.categoria || t('faturamentos:edit.composition.expense')}{d.descricao ? ` — ${d.descricao}` : ''}
                                                        {/* conferir o gasto sem sair da fatura */}
                                                        {d.comprovante && (
                                                            <a href={d.comprovante} target="_blank" rel="noreferrer" className="ms-2">{t('faturamentos:edit.composition.receipt')}</a>
                                                        )}
                                                    </td>
                                                    <td className="text-end text-muted">{moeda(d.valor)}</td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td className="ps-4">{t('faturamentos:edit.composition.expensesCount', { count: (item.despesas_itens || []).length })}</td>
                                                <td className="text-end">{moeda(item.despesas_total)}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>{t('faturamentos:edit.composition.serviceWithExpenses')}</strong></td>
                                                <td className="text-end"><strong>{moeda(item.valor_com_despesas)}</strong></td>
                                            </tr>
                                            <tr>
                                                <td>{t('faturamentos:edit.composition.billedValue')}</td>
                                                <td className="text-end">{moeda(item.valor)}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                    {item.despesas_somadas === false ? (
                                        <p className="text-muted mt-3 mb-0" style={{ fontSize: '12px' }}>
                                            <Trans t={t} i18nKey="faturamentos:edit.composition.onlyServiceNote" components={{ b: <strong /> }} />
                                        </p>
                                    ) : (!item.faturado_inclui_despesas && (
                                        <p className="text-muted mt-3 mb-0" style={{ fontSize: '12px' }}>
                                            <Trans t={t} i18nKey="faturamentos:edit.composition.lateExpensesNote" components={{ b: <strong /> }} />
                                        </p>
                                    ))}
                                </>
                            );
                        })()}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ detalheDespesasItem: null })}>{t('common:button.close')}</Button>
                    </Modal.Footer>
                </Modal>

                <Modal size="lg" show={this.state.showModalAlteracaoAtendimento} onHide={(e) => this.setState({showModalAlteracaoAtendimento: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.alteracao_servico_atendimento_titulo && t(this.state.alteracao_servico_atendimento_titulo)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={this.enviaRegistroAlteracaoAtendimento}>
                            {this.state.atendimentos_servicos.length > 0 && this.state.atendimentos_servicos.map((servico, index) => (
                                <Row key={index}>
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('faturamentos:edit.serviceName')}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="nome"
                                                value={servico.dados_servico_procedimento.nome ? servico.dados_servico_procedimento.nome : ''} 
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('faturamentos:edit.value')}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="valor"
                                                value={servico.valor ? servico.valor : ''} 
                                                onChange={(e) => this.handleChangeAtendimento(e, index, 'valor')}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            ))}
                            <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                {this.state.loading ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                    <>
                                        <FaCheck className="me-1" /> {t('common:button.save')}
                                    </>
                                )}
                            </Button>
                        </Form>
                    </Modal.Body>
                </Modal>

                <Modal size="lg" show={this.state.showModalAlteracaoServico} onHide={(e) => this.setState({showModalAlteracaoServico: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.alteracao_servico_atendimento_titulo && t(this.state.alteracao_servico_atendimento_titulo)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={this.enviaRegistroAlteracaoServicoAtendimento}>
                            <Row>
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('faturamentos:edit.value')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="valor_servico_atendimento"
                                            value={this.state.valor_servico_atendimento ? this.state.valor_servico_atendimento : ''}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                {this.state.loading ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                    <>
                                        <FaCheck className="me-1" /> {t('common:button.save')}
                                    </>
                                )}
                            </Button>
                        </Form>
                    </Modal.Body>
                </Modal>

                <Modal show={this.state.showModalAlteracaoData} onHide={(e) => this.setState({showModalAlteracaoData: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t('faturamentos:edit.changeServiceDate')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={this.enviaRegistroAlteracaoData}>
                            <Row>
                                <Col xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('faturamentos:edit.serviceDateLabel')}</Form.Label>
                                        <Form.Control
                                            type="datetime-local"
                                            name="data_servico_edicao"
                                            value={this.state.data_servico_edicao}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                {this.state.loading ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                    <>
                                        <FaCheck className="me-1" /> {t('common:button.save')}
                                    </>
                                )}
                            </Button>
                        </Form>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

FaturamentosEdit.propTypes = {
    t: PropTypes.func.isRequired,
    router: PropTypes.object,
    match: PropTypes.object,
};

export default withTranslation(['faturamentos', 'common'])(withRouter(FaturamentosEdit));